import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import { closeModal, openModal } from "../store/modal";

export const useModal = () => {
  const dispatch = useDispatch();
  const modalState = useSelector((state: RootState) => state.modal);

  function handleOpenModal() {
    dispatch(openModal());
  }

  function handleCloseModal() {
    dispatch(closeModal());
  }

  return {
    open: modalState.open,
    openModal: handleOpenModal,
    closeModal: handleCloseModal,
  };
};

export default useModal;
